module.exports = __webpack_public_path__ + "img/clip.e034b8f0.svg";